var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header header-centered" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        {
          staticClass: "header-container",
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "header-top",
              staticStyle: { "border-bottom": "none" }
            },
            [
              _c("div", { staticClass: "header-logo" }, [
                _c("div", { staticClass: "logo" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "icon",
                      attrs: { width: "94", height: "46" }
                    },
                    [_c("use", { attrs: { "xlink:href": "#svg-logo-t" } })]
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "header-bar",
              staticStyle: { "justify-content": "flex-end" }
            },
            [
              _c("div", [
                _c("span", { staticClass: "link" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "icon mr-1",
                      attrs: { width: "15", height: "15" }
                    },
                    [
                      _c("use", {
                        attrs: { "xlink:href": "#svg-internet-small" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isActiveLanguage("cs")
                    ? _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.changeLanguage("en")
                            }
                          }
                        },
                        [_vm._v("English")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isActiveLanguage("en")
                    ? _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.changeLanguage("cs")
                            }
                          }
                        },
                        [_vm._v("Česky")]
                      )
                    : _vm._e()
                ])
              ])
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }